(() => {
  let pending = null;

  const load = () => {
    if (pending) return pending;

    const root = document.querySelector("[data-mega-menu-promo-root]");
    const hasSlot = document.querySelector("[data-mega-menu-promo-slot]");

    if (!root || !hasSlot || root.dataset.megaMenuPromosLoaded === "true") {
      pending = Promise.resolve();
      return pending;
    }

    const sectionId = root.dataset.megaMenuPromoSection || "mega-menu-promos";
    const base = window.Shopify?.routes?.root || "/";
    const url = `${base}?section_id=${encodeURIComponent(sectionId)}`;

    pending = fetch(url, { credentials: "same-origin" })
      .then((response) => {
        if (!response.ok) throw new Error("mega menu promos");

        return response.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");

        for (const slot of document.querySelectorAll(
          "[data-mega-menu-promo-slot]",
        )) {
          const handle = slot.dataset.megaMenuPromoSlot;
          const context = slot.dataset.megaMenuPromoContext || "desktop";

          if (!handle) continue;

          const set = doc.querySelector(
            `[data-mega-menu-promo-set="${CSS.escape(handle)}"]`,
          );
          const source = set?.querySelector(
            `[data-mega-menu-promo-context="${context}"]`,
          );

          if (!source) continue;

          slot.replaceChildren(...source.childNodes);
        }

        root.dataset.megaMenuPromosLoaded = "true";
        document.dispatchEvent(new CustomEvent("mega-menu-promos:loaded"));
      })
      .catch(() => {
        pending = null;
      });

    return pending;
  };

  const onIntent = (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    if (
      !target.closest(
        "[data-header-nav-link], [data-header-menu-toggle], header-mobile-navigation",
      )
    ) {
      return;
    }

    load();
  };

  document.addEventListener("pointerover", onIntent, true);
  document.addEventListener("focusin", onIntent);
  document.addEventListener("click", onIntent);
})();
